import React from 'react';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/contexts/I18nContext';

interface WizardStepContainerProps {
  step: number;
  totalSteps: number;
  onNext: () => void;
  onComplete: () => void;
  onSkip?: () => void;
  isLastStep: boolean;
  isPending?: boolean;
  children: React.ReactNode;
  nextLabel?: string;
  completeLabel?: string;
}

export function WizardStepContainer({
  step,
  totalSteps,
  onNext,
  onComplete,
  onSkip,
  isLastStep,
  isPending,
  children,
  nextLabel,
  completeLabel,
}: WizardStepContainerProps) {
  const { t } = useI18n();

  const defaultNextLabel = nextLabel || t('common.next');
  const defaultCompleteLabel = completeLabel || t('common.complete_profile');

  return (
    <div className="max-w-lg mx-auto px-6 py-6 bg-white rounded-xl shadow relative">
      {/* Barra de progresso geral e link Skip no topo */}
      <div className="flex items-center justify-center mb-6 relative">
        <div className="flex-1 text-center font-medium select-none text-[#b0b0b0]">
          {step + 1} / {totalSteps}
        </div>
        {onSkip && (
          <button
            className="underline text-sm text-[#b0b0b0] absolute right-0 top-0 font-sans"
            onClick={onSkip}
            type="button"
          >
            {t('common.skip')}
          </button>
        )}
      </div>
      {/* Conteúdo do passo */}
      <div>{children}</div>
      {/* Controles de navegação */}
      <div className="flex gap-2 mt-8">
        {isLastStep ? (
          <Button
            onClick={onComplete}
            disabled={isPending}
            className="!bg-[#D72E16] text-white font-sans hover:!bg-[#D72E16] focus:!bg-[#D72E16] active:!bg-[#D72E16] rounded-full flex-1"
          >
            {isPending ? t('common.loading') : defaultCompleteLabel}
          </Button>
        ) : (
          <Button
            onClick={onNext}
            className="!bg-[#D72E16] text-white font-sans hover:!bg-[#D72E16] focus:!bg-[#D72E16] active:!bg-[#D72E16] rounded-full flex-1"
          >
            {defaultNextLabel}
          </Button>
        )}
      </div>
    </div>
  );
} 